export default __webpack_public_path__ + "static/media/MyriadProBold.4c85a900.ttf";